export default "__VITE_ASSET__BhJTyDNE__"